<template>
  <div class="page-container">
    <el-card shadow="never">
      <div style="padding: 24px; font-size: 14px; color: #606266">系统权限管理 - 角色管理（待开发）</div>
    </el-card>
  </div>
</template>

<script>
export default {};
</script>
